import { createActions } from 'redux-actions';

export const { updateInfusionSessions } = createActions('UPDATE_INFUSION_SESSIONS');
